export class vUser {
    public constructor(init?: Partial<vUser>) {Object.assign(this, init);}
    user_id!: string;
    user_name!: string;
    password_original!: string;
    first_name!: string;
    last_name!: string;
    email!: string;
    // [Write(false)]
    dtoe!: Date;
    entry_user_id!: string;
    address1!: string;
    address2!: string;
    city!: string;
    state!: string;
    zip_code!: string;
    phone1!: string;
    phone2!: string;
    is_sysop!: boolean;
    is_active!: boolean;
    authentication_token!: string;
    password_hash!: string;
    password_salt!: string;
    password_reset_token!: string;
    password_reset_token_dtoe!: Date;
    is_system_owned!: boolean;
    signature!: string;
    login_datetime!: Date;
    last_active_datetime!: Date;
    logout_datetime!: Date;
    workstation_id!: string;
    legacy_access_class!: string;
    display_user_name!: string;
    last_update_user_id!: string;
    last_update_datetime!: Date;
    agency_id!: string;
    send_new_payment_notification!: boolean;
    first_last!: string;
    last_first!: string;
    agency_name!: string;
}

